<template>
  <div id="vessel-edit-tab-gallery">
    <vs-row v-if="isFetchingPictures" style="height: 200px">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <span>写真を取得しています...</span>
      </vs-col>
    </vs-row>
    <div v-if="!isFetchingPictures" class="vx-row">
      <div
        class="vx-col w-full sm:w-1/3 lg:w-1/4 mb-base"
        v-for="(picture, index) in pictures"
        :key="picture.id"
      >
        <vx-card class="overlay-card overflow-hidden">
          <template slot="no-body">
            <div v-if="picture.isAddButton" class="add-button-box">
              <img :src="picture.src" class="responsive" />
              <vs-button
                color="rgb(255, 255, 255)"
                type="line"
                icon-pack="feather"
                icon="icon-plus"
                @click="showDialogUpload"
                >新しい写真を追加する</vs-button
              >
            </div>
            <div v-else class="picture-box">
              <img :src="picture.src" class="responsive" />
              <div class="picture-overlay">
                <br />
                <div class="picture-contents">
                  <vs-button
                    color="rgb(255, 255, 255)"
                    type="line"
                    icon-pack="feather"
                    icon="icon-eye"
                    size="small"
                    @click="openGallery(index - 1)"
                    >プレビュー</vs-button
                  ><br />
                  <vs-button
                    color="rgb(255, 255, 255)"
                    type="line"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    size="small"
                    @click="deleteVesselPicture(index - 1)"
                    >削除</vs-button
                  >
                </div>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
    </div>
    <div class="mt-4 mb-4" v-if="lightBoxPictures.length !== 0">
      <LightBox
        ref="lightbox"
        :media="lightBoxPictures"
        :show-light-box="false"
        :show-thumbs="false"
        :show-caption="false"
        :disableScroll="false"
      ></LightBox>
    </div>
    <dialog-upload-vessel-picture
      id="dialog-upload-vessel-picture"
      ref="dialogUploadVesselPicture"
    ></dialog-upload-vessel-picture>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import DialogUploadVesselPicture from "../components/DialogUploadVesselPicture";

import LightBox from "vue-image-lightbox";

const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseVesselEdit"
);

export default {
  components: {
    DialogUploadVesselPicture,
    LightBox
  },
  props: {
    data: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapState({
      isFetchingPictures: state => state.isFetchingPictures,
      pictures: state => state.pictures,
      lightBoxPictures: state => state.lightBoxPictures
    })
  },
  data() {
    return {
      photo: require("@/assets/images/sample/ship_images01.jpg")
    };
  },
  methods: {
    ...mapActions([
      "fetchVessel",
      "deletePicture",
      "fetchPictures",
      "deletePicture"
    ]),
    showDialogUpload() {
      this.$refs.dialogUploadVesselPicture.show();
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
    async deleteVesselPicture(index) {
      this.$vs.loading();

      let pictureInfo = this.lightBoxPictures[index].picture;
      let payload = {
        vesselId: this.$route.params.vesselId,
        linkId: pictureInfo.id,
        pictureId: pictureInfo.picture.id,
        index: index + 1
      };
      try {
        await this.deletePicture(payload);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "写真を削除しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "top-right"
        });
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "写真の削除に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "top-right"
        });
      }
    }
  },
  mounted() {},
  async created() {
    await this.fetchPictures({
      vesselId: this.$route.params.vesselId,
      newPictureId: null
    });
  }
};
</script>

<style lang="scss">
.add-button-box {
  width: 100%;
  background: #7367f0;
}

.add-button-box {
  position: relative;
}

.add-button-box img {
  width: 250px;
  height: 167px;
  opacity: 0;
}

.add-button-box button {
  position: absolute;
  top: 45%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
}

.add-button-box p {
  position: absolute;
  top: 70%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  color: white;
}

.add-button-contents {
  padding: 0 10px 5px;
  -webkit-transform: scale3d(0, 0, 1);
  transform: scale3d(0, 0, 1);
  -webkit-transition: transform 0.4s, color 0.4s;
  transition: transform 0.4s, color 0.4s;
}
.picture-box {
  width: 100%;
  background: black;
  position: relative;
  overflow: hidden;
}
.picture-box img {
  width: 250px;
  height: 167px;
  object-fit: cover;
  display: block;
  width: 100%;
  opacity: 1;
  -webkit-transition: opacity 0.4s, transform 0.4s;
  transition: opacity 0.4s, transform 0.4s;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

.picture-box button {
  position: relative;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
}

.picture-box:hover img {
  opacity: 0.3;
  -webkit-transform: scale3d(1.2, 1.2, 1);
  transform: scale3d(1.2, 1.2, 1);
}

.picture-overlay {
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
}
.picture-box:hover .picture-overlay {
  opacity: 1;
}
.picture-contents {
  padding: 0 10px 5px;
  color: white;
  -webkit-transform: scale3d(0, 0, 1);
  transform: scale3d(0, 0, 1);
  -webkit-transition: transform 0.4s, color 0.4s;
  transition: transform 0.4s, color 0.4s;
}
.picture-box:hover .picture-contents {
  color: white;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

.vue-lb-container {
  z-index: 100000;
}
</style>
